import { StyleguideImportSections } from "./StyleguideImportData";

enum StyleguideSectionCategoryType {
    About = "about",
    Foundations = "foundations",
    Components = "components"
}

enum StyleguideSectionType {
    About = "about",
    Colors = "colors",
    Spacing = "spacing",
    TextStyles = "textStyles",
    Icons = "icons",
    Components = "components"
}

enum StyleguideDataToEdit {
    Description = "description",
    Colors = "colors",
    TextStyles = "textStyles",
    Components = "components"
}

interface StyleguideSection {
    name: string;
    categoryType?: StyleguideSectionCategoryType;
    thumbnail?: string;
    value?: StyleguideSectionType;
    figmaImportKey?: StyleguideImportSections;
    children?: StyleguideSection[];
    delegateNavigationToFirstChild?: boolean;
}

export {
    StyleguideSectionCategoryType,
    StyleguideSection,
    StyleguideSectionType,
    StyleguideDataToEdit
};
